import { render, staticRenderFns } from "./tdgMapTesting.vue?vue&type=template&id=4da729f4"
import script from "./tdgMapTesting.vue?vue&type=script&lang=ts"
export * from "./tdgMapTesting.vue?vue&type=script&lang=ts"
import style0 from "./tdgMapTesting.vue?vue&type=style&index=0&id=4da729f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports